<img
  class="image fixed right-0 top-0 hidden h-[104px] w-[223px] sm:hidden sm:max-w-screen-sm md:hidden lg:block xl:block"
  src="../../assets/images/image-21@2x.png"
  alt="image-"
/>
<div
  class="right__content sm:bg-[#fcfcfc rounded-lg bg-white shadow-md sm:p-[2.9rem] xl:p-[3.12rem]"
>
  <h1 class="text-2xl">Admin Login</h1>

  <p class="mb-5">Enter your details to access your Mango account</p>

  <form class="flex flex-col gap-5" [formGroup]="form" (ngSubmit)="login()">
    <div class="flex flex-col gap-[0.38rem]" style="gap: 0.38rem">
      <app-input-label labelFor="email" labelClass="label--bottom-margin"
        >Email</app-input-label
      >
      <!-- <div class="">
        <input
          id="email"
          name="email"
          type="email"
          autocomplete="email"
          placeholder="Email"
          formControlName="email"
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:text-sm sm:leading-6"
        />
      </div> -->
      <app-input placeholder="Enter email" formControlName="email"> </app-input>
    </div>

    <div class="gap flex flex-col" style="gap: 0.38rem">
      <label
        for="Password"
        class="block text-sm font-medium leading-6 text-gray-900"
        >Password</label
      >
      <div class="">
        <div class="relative mt-0">
          <input
            id="Password"
            name="password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            autocomplete="password"
            placeholder="******"
            formControlName="password"
            class="input--padding block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:text-sm sm:leading-6"
          />
          <span
            (mousedown)="togglePasswordVisibility()"
            class="absolute inset-y-0 end-0 grid cursor-pointer place-content-center px-4"
          >
            <svg
              *ngIf="!isPasswordVisible"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.35537 5.53854C2.19221 5.15782 1.7513 4.98146 1.37058 5.14463C0.989854 5.30779 0.81349 5.7487 0.976657 6.12942L2.35537 5.53854ZM12.9887 11.1079L12.714 10.41L12.9887 11.1079ZM7.63866 11.5169C7.86457 11.1698 7.76625 10.7052 7.41906 10.4793C7.07188 10.2534 6.60729 10.3517 6.38139 10.6989L7.63866 11.5169ZM5.20404 12.5083C4.97814 12.8555 5.07646 13.3201 5.42364 13.546C5.77083 13.7719 6.23541 13.6735 6.46132 13.3264L5.20404 12.5083ZM19.022 6.12942C19.1852 5.7487 19.0088 5.30779 18.6281 5.14463C18.2474 4.98146 17.8065 5.15782 17.6433 5.53855L19.022 6.12942ZM15.8327 9.27468L15.3194 8.72783V8.72783L15.8327 9.27468ZM16.5524 11.055C16.8452 11.3479 17.3201 11.3479 17.613 11.055C17.9059 10.7621 17.9059 10.2872 17.613 9.99435L16.5524 11.055ZM9.24935 13.7507C9.24935 14.1649 9.58514 14.5007 9.99935 14.5007C10.4136 14.5007 10.7493 14.1649 10.7493 13.7507H9.24935ZM13.5374 13.3264C13.7633 13.6735 14.2279 13.7719 14.5751 13.546C14.9222 13.32 15.0206 12.8555 14.7947 12.5083L13.5374 13.3264ZM4.69635 9.80501C4.98924 9.51212 4.98924 9.03725 4.69635 8.74435C4.40345 8.45146 3.92858 8.45146 3.63569 8.74435L4.69635 9.80501ZM2.38569 9.99435C2.09279 10.2872 2.09279 10.7621 2.38569 11.055C2.67858 11.3479 3.15345 11.3479 3.44635 11.055L2.38569 9.99435ZM9.99935 10.9173C7.35879 10.9173 5.46068 9.60359 4.19478 8.24031C3.56205 7.55891 3.09781 6.87515 2.79226 6.36183C2.6399 6.10588 2.52817 5.89427 2.45565 5.74923C2.41942 5.67676 2.39306 5.62108 2.37639 5.585C2.36806 5.56696 2.36216 5.55383 2.35866 5.54597C2.35691 5.54204 2.35576 5.53942 2.35522 5.53817C2.35494 5.53754 2.35482 5.53726 2.35485 5.53732C2.35486 5.53735 2.35491 5.53747 2.355 5.53767C2.35504 5.53777 2.35514 5.53799 2.35516 5.53804C2.35526 5.53828 2.35537 5.53854 1.66602 5.83398C0.976657 6.12942 0.976789 6.12973 0.97693 6.13006C0.97699 6.1302 0.977141 6.13055 0.977261 6.13083C0.977502 6.13139 0.977781 6.13204 0.9781 6.13277C0.978737 6.13425 0.979531 6.13608 0.980482 6.13825C0.982383 6.14261 0.984912 6.14836 0.988072 6.15547C0.994391 6.16968 1.00324 6.18931 1.01464 6.21399C1.03744 6.26336 1.07049 6.33301 1.11401 6.42005C1.20099 6.59401 1.33015 6.83813 1.50332 7.12906C1.84881 7.70948 2.37415 8.48405 3.09559 9.26099C4.53802 10.8144 6.80657 12.4173 9.99935 12.4173V10.9173ZM12.714 10.41C11.9192 10.7228 11.0177 10.9173 9.99935 10.9173V12.4173C11.2142 12.4173 12.3017 12.1843 13.2634 11.8058L12.714 10.41ZM6.38139 10.6989L5.20404 12.5083L6.46132 13.3264L7.63866 11.5169L6.38139 10.6989ZM18.3327 5.83398C17.6433 5.53855 17.6434 5.53839 17.6435 5.53825C17.6435 5.53821 17.6435 5.53807 17.6436 5.53799C17.6436 5.53783 17.6437 5.5377 17.6437 5.5376C17.6438 5.5374 17.6439 5.5373 17.6439 5.53731C17.6438 5.53734 17.6436 5.5378 17.6433 5.53868C17.6425 5.54045 17.641 5.54392 17.6387 5.54904C17.6341 5.55926 17.6265 5.57604 17.6159 5.59887C17.5946 5.64455 17.5611 5.71438 17.5152 5.80442C17.4232 5.98466 17.282 6.24488 17.0895 6.55388C16.703 7.17406 16.1174 7.97883 15.3194 8.72783L16.346 9.82153C17.2635 8.96035 17.9278 8.04477 18.3625 7.34714C18.5806 6.99725 18.7426 6.6992 18.8514 6.4859C18.9059 6.37917 18.9471 6.29341 18.9754 6.2327C18.9895 6.20233 19.0005 6.17821 19.0082 6.16083C19.0121 6.15215 19.0152 6.14514 19.0175 6.13989C19.0187 6.13726 19.0196 6.13507 19.0204 6.13332C19.0207 6.13245 19.0211 6.13169 19.0213 6.13104C19.0215 6.13071 19.0216 6.13041 19.0217 6.13015C19.0218 6.13001 19.0219 6.12983 19.0219 6.12976C19.022 6.12959 19.022 6.12942 18.3327 5.83398ZM15.3194 8.72783C14.6126 9.39129 13.7474 10.0032 12.714 10.41L13.2634 11.8058C14.5091 11.3155 15.5314 10.5861 16.346 9.82153L15.3194 8.72783ZM15.3024 9.80501L16.5524 11.055L17.613 9.99435L16.363 8.74435L15.3024 9.80501ZM9.24935 11.6673V13.7507H10.7493V11.6673H9.24935ZM12.36 11.5169L13.5374 13.3264L14.7947 12.5083L13.6173 10.6989L12.36 11.5169ZM3.63569 8.74435L2.38569 9.99435L3.44635 11.055L4.69635 9.80501L3.63569 8.74435Z"
                fill="#D0D5DD"
              />
            </svg>

            <svg
              *ngIf="isPasswordVisible"
              class="h-5 w-5 text-mango-lightGray"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'cursor-not-allowed': (isLoading$ | async) || form.invalid
      }"
    >
      <button
        mango-button
        [loading]="(isLoading$ | async) || form.invalid"
        [disabled]="(isLoading$ | async) || form.invalid"
        class="w-full justify-center"
      >
        <span *ngIf="isLoading$ | async" spin></span>
        @if (!(isLoading$ | async)) {
          Login
        }
      </button>
    </div>

    <a
      routerLink="/auth/forgot-password"
      class="cursor-pointer text-center text-mango"
    >
      Forgot Password?
    </a>
  </form>
</div>
<router-outlet></router-outlet>